var _path, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconStarRaitingYellow = function SvgIconStarRaitingYellow(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 52",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9657 1.80774C27.396 0.478718 28.1031 0.478718 28.5362 1.80774L33.623 17.467C34.056 18.7946 35.5525 19.8825 36.9489 19.8825H53.4166C54.813 19.8825 55.0323 20.5539 53.9017 21.3746L40.5804 31.0532C39.4484 31.8739 38.877 33.6331 39.31 34.9608L44.3982 50.62C44.8299 51.949 44.2584 52.3642 43.1279 51.5421L29.8051 41.8649C28.6746 41.0442 26.8246 41.0442 25.6954 41.8649L12.3727 51.5421C11.2421 52.3642 10.6707 51.949 11.1023 50.62L16.1919 34.9608C16.6222 33.6331 16.0507 31.8739 14.9216 31.0532L1.59745 21.3746C0.468261 20.5539 0.68615 19.8825 2.08393 19.8825H18.5503C19.9481 19.8825 21.4445 18.7946 21.8762 17.467L26.9657 1.80774Z",
    fill: "url(#paint0_linear_yellow)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_yellow",
    x1: 0.874725,
    y1: 0.810974,
    x2: 0.874725,
    y2: 51.9645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA93"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconStarRaitingYellow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-star-raiting-yellow.ddf90b56.svg";
export { ForwardRef as ReactComponent };